// extracted by mini-css-extract-plugin
export default {"sortList":"SortList_sortList__3KRfn","sortList__item":"SortList_sortList__item__CUjeG"};